module.exports = __webpack_public_path__ + "static/img/hsfbanner2.4faac26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hsfbanner2.jpg
// module id = 18cD
// module chunks = 5